import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { User } from "../models/user";
import { Market } from "../models/market";

@Injectable()
export class UserService {
  keepSessionAliveInterval: number;

  constructor(private apiService: ApiService) {}

  getAllUsers() {
    return this.apiService.get("User/GetAll").map((res) => {
      if (res && res.values) {
        return res.values.map((value) => new User(value));
      }
    });
  }

  getAllMarkets() {
    return this.apiService.get("User/Markets").map((res) => {
      if (res && res.values) {
        return res.values.map((value) => new Market(value));
      }
    });
  }

  getUserById(userId: number) {
    return this.apiService.get("User/" + userId).map((res) => {
      if (res && res.value) {
        return new User(res.value);
      }
    });
  }

  updateDefaultLanguage(userId: number, languageId: number) {
    return this.apiService
      .post("User/DefaultLanguage/" + userId + "/" + languageId, {})
      .map((res) => {
        if (res && res.value) {
          return res.value;
        }
      });
  }

  saveUser(user: User) {
    return this.apiService.post("User/Save", user).map((res) => {
      if (res && res.success === 1 && res.values) {
        return res.values.map((value) => new User(value));
      }
      if (res.success === 2) {
        return res.message;
      }
    });
  }

  deleteUser(user: User) {
    return this.apiService.delete("User/" + user.id).map((res) => {
      if (res && res.values) {
        return res.values.map((value) => new User(value));
      }
    });
  }

  unlockUser(user: User) {
    // transform login to avoid keeping /

    return this.apiService
      .get("User/Unlock?login=" + encodeURI(user.login))
      .map((res) => {
        if (res && res.values) {
          return res.values.map((value) => new User(value));
        }
      });
  }

  keepSessionAlive() {
    this.keepSessionAliveInterval = setInterval(() => {
      this.apiService.get("User/KeepSessionAlive").subscribe();
    }, 10 * 60 * 1000);
  }

  stopKeepingSessionAlive() {
    clearInterval(this.keepSessionAliveInterval);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts